<template>
  <SlottedDialog :externaltrigger="externaltrigger" :externalCloseTrigger="externalCloseTrigger"
    :title="$t('servicesystem.common_objects.commonterms.new_object', { okey: $t('servicesystem.common_objects.contract.contract') })">
    <template v-slot:content>
      <v-form v-model="valid" :key="externaltrigger">
        <v-container>
          <CustomerSelect v-model="draft.CustomerId" externaledit hideIcon class="mb-3">
          </CustomerSelect>
          <QTextField v-model="draft.Name" :label="$t('servicesystem.common_objects.commonterms.name')" externaledit
            clearable :rules="[requiredRule]" class="mb-3">
          </QTextField>
          <ContractTypeSelect v-model="draft.ContractTypeId" externaledit hideIcon class="mb-3">
          </ContractTypeSelect>
        </v-container>
      </v-form>
    </template>

    <template v-slot:buttons>
      <v-btn outlined @click="$emit('RequestClose')">
        {{ $t('servicesystem.common_objects.commonterms.cancel') }}
      </v-btn>
      <v-spacer />
      <v-btn color="primary" :disabled="!valid" :loading="createLoading" @click="create()">
        {{ $t('servicesystem.common_objects.commonterms.create') }}
      </v-btn>
    </template>
  </SlottedDialog>
</template>


<script>
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import QTextField from "@/components/Inputs/QTextField.vue";
import clientAPI from "@/api/ClientAPIMixin.js";
import ContractTypeSelect from "../Inputs/EntityDropdowns/ContractTypeSelect.vue";

export default {
  name: "NewContractDialog",
  props: {
    externaltrigger: Number,
    externalCloseTrigger: Number,
    contractTypeId: [String, Number],
    customerId: String,
  },
  components: {
    SlottedDialog,
    CustomerSelect,
    QTextField,
    ContractTypeSelect,
  },
  mixins: [clientAPI],

  data() {
    return {
      createLoading: false,
      draft: {},
      valid: false,
    };
  },

  methods: {
    setDetails() {
      this.draft = {
        Id: 0,
        Name: '',
        CustomerId: this.customerId,
        ContractTypeId: Number(this.contractTypeId),
        Active: true,
        ContractComment: '',
        InvoiceComment: '',
      }
    },

    async create() {
      this.createLoading = true;
      const payload = Object.assign({}, this.draft);
      await this.createContract(payload)
        .then(response => {
          this.$emit('Added', response);
          this.createLoading = false;
          this.$emit('RequestClose');
        })
        .catch((e) => {
          this.createLoading = false;
          console.error('createContract', e)
        })
    },
  },

  computed: {},

  watch: {
    externaltrigger: function () {
      this.setDetails();
    }
  },
};
</script>


<style lang="scss" scoped></style>
